import React from "react";
import Avatar from "../Avatar";
import "./styles.scss";

const DEFAULT_MAX_VISIBLE = 5;

/**
 * Pilha de avatares dos usuários com acesso a um painel (pipeline). Mostra no
 * máximo `maxVisible` avatares sobrepostos + um chip "+N" com o restante —
 * funciona igual com 1 ou com 100 membros.
 */
export const PipelineMembersAvatars = ({
    members,
    size = 28,
    maxVisible = DEFAULT_MAX_VISIBLE,
    showLabel = true,
    emptyLabel = 'Sem usuários com acesso',
}) => {
    const list = members ?? [];
    const visible = list.slice(0, maxVisible);
    const extra = list.slice(maxVisible);

    if (list.length === 0) {
        return <span className="pipeline-members-avatars pipeline-members-avatars--empty">{emptyLabel}</span>;
    }

    return (
        <span className="pipeline-members-avatars">
            <span className="pipeline-members-avatars__stack">
                {visible.map(member => (
                    <span key={member.id} className="pipeline-members-avatars__avatar" title={member.name}>
                        <Avatar name={member.name} photo={member.photo_url} size={size} />
                    </span>
                ))}
                {extra.length > 0 &&
                    <span
                        className="pipeline-members-avatars__avatar pipeline-members-avatars__more"
                        style={{ width: size, height: size }}
                        title={extra.map(member => member.name).join(', ')}
                    >
                        +{extra.length}
                    </span>
                }
            </span>
            {showLabel &&
                <span className="pipeline-members-avatars__label">
                    {list.length} usuário{list.length === 1 ? '' : 's'}
                </span>
            }
        </span>
    );
};

export default PipelineMembersAvatars;
